import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { HeadphonesIcon, BookOpenIcon, PlayCircleIcon, MailIcon } from 'lucide-react';
const resources = [{
  icon: HeadphonesIcon,
  type: 'Audio',
  title: 'Meditación de Claridad',
  description: 'Reprograma tu mente para la abundancia. 20 minutos que cambian todo.'
}, {
  icon: BookOpenIcon,
  type: 'Ebook',
  title: 'Los 7 Principios del Emprendedor Consciente',
  description: 'El manual que nadie te dio al comenzar.'
}, {
  icon: PlayCircleIcon,
  type: 'Masterclass',
  title: 'De Empleado a Emprendedor',
  description: 'La clase que ha transformado a cientos. Gratis. Por tiempo limitado.'
}, {
  icon: MailIcon,
  type: 'Newsletter',
  title: 'Expansión Semanal',
  description: 'Reflexiones, estrategias y transmisiones directas a tu bandeja.'
}];
export function FreeResources() {
  const [email, setEmail] = useState('');
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Email submitted:', email);
    setEmail('');
  };
  return <section id="recursos" ref={ref} className="py-24 md:py-32 bg-white" data-id="element-151">
      <div className="max-w-6xl mx-auto px-6" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-153">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-154">
            Comienza aquí
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-155">
            Recursos Gratuitos
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-xl mx-auto" data-id="element-156">
            El primer paso siempre es tuyo. Sin costo.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-157">
          {resources.map((resource, index) => <motion.div key={resource.title} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="bg-cream rounded-2xl p-6 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-158">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-159">
                <resource.icon className="w-7 h-7 text-gold" data-id="element-160" />
              </div>
              <span className="inline-block px-3 py-1 bg-beige text-charcoal-mid text-xs font-medium rounded-full mb-3" data-id="element-161">
                {resource.type}
              </span>
              <h3 className="font-serif text-lg text-charcoal mb-2" data-id="element-162">
                {resource.title}
              </h3>
              <p className="font-sans text-sm text-charcoal-mid leading-relaxed" data-id="element-163">
                {resource.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="max-w-xl mx-auto" data-id="element-164">
          <div className="bg-beige rounded-3xl p-8 text-center" data-id="element-165">
            <h3 className="font-serif text-2xl text-charcoal mb-2" data-id="element-166">
              Accede a todos los recursos gratuitos
            </h3>
            <p className="font-sans text-charcoal-mid mb-6" data-id="element-167">
              Déjame tu email y te envío acceso inmediato.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3" data-id="element-168">
              <input type="email" required placeholder="tu@email.com" value={email} onChange={e => setEmail(e.target.value)} className="flex-1 px-5 py-3 bg-white border border-beige-dark rounded-full font-sans text-charcoal focus:outline-none focus:border-gold transition-colors" data-id="element-169" />
              <button type="submit" className="px-6 py-3 bg-gold text-white font-sans font-medium rounded-full hover:bg-gold/90 transition-colors duration-300 whitespace-nowrap" data-id="element-170">
                Quiero acceso gratuito
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>;
}